import { render, staticRenderFns } from "./Jumbos.vue?vue&type=template&id=8646d102&scoped=true&"
import script from "./Jumbos.vue?vue&type=script&lang=js&"
export * from "./Jumbos.vue?vue&type=script&lang=js&"
import style0 from "./Jumbos.vue?vue&type=style&index=0&id=8646d102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8646d102",
  null
  
)

export default component.exports